import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, catchError, switchMap, finalize, tap } from 'rxjs/operators';
import { UserModel } from '../_models/user.model';
import { AuthModel } from '../_models/auth.model';
import { AuthHTTPService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { StoreUser, GetUser, DestroyUser } from 'src/app/store/actions/user.action';


@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private isLoadingSubject: BehaviorSubject<boolean>;
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

  // public fields
  currentUser$: Observable<UserModel>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<UserModel>;
  user: UserModel;

  get currentUserValue(): UserModel {
    return this.currentUserSubject.value;
  }

  constructor(
    private authHttpService: AuthHTTPService,
    private router: Router,
    private store: Store
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<UserModel>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  private currentToken: string;
  /**
   * 
   * @returns 
   */
  getToken() {
    // return this.currentToken;
    return sessionStorage.getItem(this.authLocalStorageToken);
  }

  /**
   * 
   * @returns 
   */
  getAccessToken() {

    // return this.currentToken;
    if (sessionStorage.getItem(this.authLocalStorageToken) === null) {
      return null;
    }
    return JSON.parse(sessionStorage.getItem(this.authLocalStorageToken)).access_token;

  }
  /**
   * 
   * @param token 
   */
  setFongesoftAccessToken(token: string) {
    // this.currentToken = token;
    sessionStorage.setItem(this.authLocalStorageToken, "{\"access_token\":\"" + token + "\"}")

  }
  /**
   * 
   * @returns 
   */
  getRefreshToken() {

    if (sessionStorage.getItem(this.authLocalStorageToken) === null) {
      return null;
    }
    return JSON.parse(sessionStorage.getItem(this.authLocalStorageToken)).refresh_token;

  }

  /**
   * 
   * @returns 
   */
  getRegion() {
    if (JSON.parse(sessionStorage.getItem('user')) == null) {
      return null;
    }
    return JSON.parse(sessionStorage.getItem('user')).region;
  }
  /**
   * 
   * @param region 
   */
  setRegion(region) {
    let userUpdate = JSON.parse(sessionStorage.getItem('user'));
    userUpdate.region = region;
    sessionStorage.setItem("user", JSON.stringify(userUpdate))
  }


  /**
   * 
   */
  updateFirstConnexion() {
    let u = JSON.parse(sessionStorage.getItem('user'))
    u.premiere_connexion = 0;
    sessionStorage.setItem("user", JSON.stringify(u))

  }

  async sendPinByEmail(data): Promise<any> {
    try {
      const o = await this.authHttpService.sendPinByEmail(data).toPromise();
      if (o.status == 200) {
        return true;
      } else if (o.status == 202) {
        return {msg:o.body,status:202};
      } else {
        return o;
      }
    } catch (error) {
      throw error;  // Propagation de l'erreur pour gestion dans l'appelant
    }

  }

  async sendPinBySMS(data): Promise<any> {

    // 
    try {
      const o = await this.authHttpService.sendPinBySMS(data).toPromise();
      if (o.status == 200) {
        return true;
      } else if (o.status == 202) {
        return {msg:o.body,status:202};
      } else {
        return o;
      }
    } catch (error) {
      throw error;  // Propagation de l'erreur pour gestion dans l'appelant
    }

  }

  doubleAuthLogin(data){
    return this.authHttpService.doubleAuthLogin(data)
  }


  // public methods
  loginV2(email: string, password: string, url: string): any {

    this.isLoadingSubject.next(true);
    const responseLogin = this.authHttpService.loginV2(email, password, url)
    // return responseLogin
    return responseLogin.pipe(map((o) => {

      this.isLoadingSubject.next(false);
      if (o.status === 200) {
        this.user = o.body.user;
        const result = this.setAuthFromLocalStorage(o.body, url);
        this.isLoadingSubject.next(false);


        
        return { status: o.status, body: o.body };

      } else if (o.status === 206) {

        // console.log(206,o.body)
        this.isLoadingSubject.next(false);
        return { status: o.status, body: o.body };

      }else if (o.status === 401) {
 
        this.isLoadingSubject.next(false);
        return { status: o.status, body: o.body };

      } else {
        
        this.isLoadingSubject.next(false);
        // return {status:o.status,body:o.body};
        return of(undefined)
      }
    }))

    // return of(null)

  }



  // public methods
  login(email: string, password: string, url: string): Observable<UserModel> {

    return this.authHttpService.login(email, password, url).pipe(
      map((auth: any) => {

        this.user = auth.user;
        const result = this.setAuthFromLocalStorage(auth, url);
        this.isLoadingSubject.next(false);
        return auth.user;
      }),
      catchError((err) => {
        console.log(err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  /**
  * 
  * @param token 
  * @param url 
  */

  loginFongesoft(token, url: string): Observable<UserModel> {

    this.isLoadingSubject.next(true);
    return this.authHttpService.loginFongesoft(token, url).pipe(
      map((auth: any) => {
        this.user = auth.user;
        const result = this.setAuthFromLocalStorage(auth, url);
        this.isLoadingSubject.next(false);
        return auth.user;
      }),
      catchError((err) => {
        // console.log(err);
        return of(err);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  /**
   * 
   */
  logout() {
    this.isLoadingSubject.next(true);
    this.authHttpService.logout().subscribe()
    this.isLoadingSubject.next(false)
    sessionStorage.clear();
    //this.removeUserFromStore();
    this.router.navigateByUrl('/auth/login');

  }

  refreshToken() {
    return this.authHttpService.refreshToken(this.getRefreshToken())
      .pipe(tap((token: any) => {
        this.updateToken(token);
      }));

  }

  updateToken(token) {
    sessionStorage.setItem(this.authLocalStorageToken, JSON.stringify(token));
  }

  getUser(): UserModel {

    return this.getUserFromLocalStorage();
  }

  getUserByToken(): Observable<UserModel> {

    this.isLoadingSubject.next(true);
    const user = this.getUserFromLocalStorage();
    this.isLoadingSubject.next(false);
    if (user) {
      this.currentUserSubject = new BehaviorSubject<UserModel>(user);
    }
    return of(user);

  }


  registration(user: UserModel): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.createUser(user).pipe(
      map(() => {
        this.isLoadingSubject.next(false);
      }),
      switchMap(() => this.login(user.identifiant, user.password, user.url)),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  /**
   * 
   * @param email 
   * @param url 
   * @returns 
   */
  forgotPassword(email: string, url: string): Observable<boolean> {
    this.isLoadingSubject.next(true);
    return this.authHttpService
      .forgotPassword(email, url)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  /**
   * 
   * @param respBody 
   * @param url 
   * @returns 
   */
  // private methods
  public setAuthFromLocalStorage(respBody: any, url: string): boolean {
    // store auth accessToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (respBody) {

      // let toks = {accessToken:respBody.accessToken,
      //   refreshToken:respBody.refreshToken,expiresIn:respBody.expiresIn};
      // localStorage.setItem(this.authLocalStorageToken,JSON.stringify(toks));

      let token = respBody.access_token;
      sessionStorage.setItem(this.authLocalStorageToken, JSON.stringify(token));

      sessionStorage.setItem('user', JSON.stringify({
        id: respBody.user.id_utilisateur,
        name: respBody.user.name,
        email: respBody.user.email,
        token: respBody.access_token,
        region: respBody.user.atpro,
        url: url,
        identifiant: respBody.user.identifiant,
        nom: respBody.user.nom,
        prenom: respBody.user.prenom,
        role: respBody.libelle_atpro,
        autorisation: respBody.autorisation,
        preferences: respBody.preferences,
        premiere_connexion: respBody.user.premiere_connexion,
        type_login: respBody.user.type_login,
        telephone: respBody.user.telephone
      }));

      // this.snack.openFromComponent(AuthSnackWarningComponent,
      //   {
      //     data: 'Bienvenue',
      //     duration: 30000,
      //     panelClass: ['success-snackbar']});


      return true;
    }
    return false;
  }


  /**
   * 
   */
  private removeUserFromStore() {
    let u = this.store.select(state => state.user);
    u.subscribe(x => {
      this.store.dispatch(new DestroyUser(x))
    });
  }


  /**
   * 
   * @returns 
   */
  private getUserFromLocalStorage(): UserModel {
    try {
      const u = JSON.parse(
        sessionStorage.getItem('user')
      );

      return u;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}


